import { AuxiliumComponent } from "../auxilium-component";

export default class Loading extends AuxiliumComponent {
	static observable = ["type", "size"];

	parsedCallback() {
		this.#ChangeType();
	}

	#ChangeType() {
		this.innerHTML = (() => {
			switch (this.type?.toLowerCase()) {
				case "image": return '<div class="loading--image"></div>';
				default: return '<div class="pv-loading-container"><div class="pv-loading-icon"></div></div>';
			}
		})();
	}

	attributeChanged(name, _, __) {
		if (name === "type") {
			this.#ChangeType();
		}
	}
}
